import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/PRTR.png")